import { Link } from 'react-router-dom';
import suitupLogo from '../assets/suitup-logo.png';
import WelcomeBackground from '../components/WelcomeBackground';

const ORANGE = '#E8981E';

const EnvelopeIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const PersonIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="8" r="4" />
    <path d="M4 20c0-4 3.6-6 8-6s8 2 8 6" />
  </svg>
);

const ProfileIcon = () => {
  const INK = '#3a2c20';

  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M6.4 3.4h7.3L17.6 7.3v11.3a1.7 1.7 0 0 1-1.7 1.7H6.4a1.7 1.7 0 0 1-1.7-1.7V5.1a1.7 1.7 0 0 1 1.7-1.7Z"
        fill="#fff"
        stroke={INK}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M13.4 3.4v3.4a1 1 0 0 0 1 1h3" stroke={INK} strokeWidth="1.6" strokeLinejoin="round" />
      <circle cx="9.3" cy="9.4" r="1.9" fill={INK} />
      <path d="M6.4 14.2c.3-1.8 1.4-2.9 2.9-2.9s2.6 1.1 2.9 2.9Z" fill={INK} />
      <g stroke={INK} strokeWidth="1.5" strokeLinecap="round">
        <path d="M6.4 16.4h9" />
        <path d="M6.4 18.4h6.4" />
      </g>
      <circle cx="16.9" cy="17.4" r="3.9" fill={ORANGE} stroke="#fff" strokeWidth="1.2" />
      <path d="m15.2 17.5 1.2 1.2 2.2-2.4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

const SearchIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="10.5" cy="10.5" r="6" />
    <path d="m15.5 15.5 4 4" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#111" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="3" y="7" width="18" height="13" rx="2" />
    <path d="M9 7V5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2" />
    <path d="M3 12h18" />
  </svg>
);

const steps = [
  { n: 1, title: 'פרופיל', desc: 'פרטים מקצועיים וקורות חיים', Icon: ProfileIcon },
  { n: 2, title: 'העדפות', desc: 'תחומי עניין ותפקידים', Icon: SearchIcon },
  { n: 3, title: 'משרות', desc: 'התאמות והגשה מהירה', Icon: BriefcaseIcon },
];

const Welcome = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-[#fbf4ea]">
      <WelcomeBackground />

      <div className="relative mx-auto flex min-h-screen w-full max-w-md flex-col px-7 pb-7 pt-24 lg:max-w-5xl lg:px-12 lg:pb-12 lg:pt-12">
        <header className="mt-1 flex items-center justify-center gap-4 lg:justify-end">
          <div className="flex flex-col items-end leading-tight">
            <span className="block whitespace-nowrap text-sm font-semibold text-[#3a2c20]">מצאו את עבודת החלומות</span>
            <span
              className="mt-1 block w-full text-[1.45rem] font-extrabold leading-none"
              style={{ color: ORANGE, textAlign: 'justify', textAlignLast: 'justify' }}
            >
              בענף המשפט
            </span>
          </div>
          <span className="h-12 w-px flex-shrink-0 bg-gray-300" />
          <img src={suitupLogo} alt="suitUp" className="h-14 w-auto flex-shrink-0" />
        </header>

        <section className="mx-auto mt-16 max-w-[17rem] text-right lg:mx-0 lg:mt-20 lg:max-w-md">
          <h1 className="text-[1.35rem] font-extrabold leading-tight text-[#2f241a] lg:text-3xl">התחל כאן.</h1>
          <p className="mt-2 text-[0.95rem] font-bold leading-tight lg:text-lg" style={{ color: ORANGE }}>
            היעד: המשרה הבאה שלך.
          </p>
          <p className="mt-2 text-xs leading-5 text-gray-500 lg:text-sm">
            למציאת משרות, ניהול העדפות והגשת מועמדות בצורה פשוטה.
          </p>
        </section>

        <div className="mt-auto lg:mt-10">
          <div className="mx-auto w-full max-w-[10rem] space-y-2 lg:mx-0 lg:flex lg:max-w-none lg:gap-3 lg:space-y-0">
            <Link
              to="/register"
              className="relative flex h-9 items-center justify-center rounded-md border border-[#a86a13] text-xs font-extrabold text-[#2f241a] shadow-md transition hover:brightness-105 lg:w-40"
              style={{ background: `linear-gradient(180deg, #F8B834 0%, ${ORANGE} 100%)` }}
            >
              <span className="absolute left-5 flex items-center">
                <EnvelopeIcon />
              </span>
              הרשמה
            </Link>
            <Link
              to="/login"
              className="relative flex h-9 items-center justify-center rounded-md border text-xs font-extrabold text-[#2f241a] shadow-sm transition hover:bg-orange-50 lg:w-40"
              style={{ borderColor: '#d2b98e', background: 'rgba(255,255,255,0.62)' }}
            >
              <span className="absolute left-5 flex items-center">
                <PersonIcon />
              </span>
              התחברות
            </Link>
          </div>
        </div>

        <section className="mx-5 mt-6 rounded-2xl border border-[#efe4cf] bg-white/80 px-5 py-6 shadow-sm backdrop-blur-sm lg:-mx-16 lg:mt-auto lg:px-6 lg:py-5">
          <div className="text-center">
            <h2 className="text-base font-extrabold leading-tight text-[#2f241a] lg:text-2xl">מצאו משרות שמתאימות לכם</h2>
            <p className="mt-2 text-xs text-gray-600 lg:text-base">עדכנו פרטים, קבלו התאמות והגישו מועמדות</p>
          </div>

          <div className="mt-5 divide-y divide-[#eee2cd] lg:grid lg:grid-cols-3 lg:divide-x lg:divide-y-0 lg:divide-x-reverse">
            {steps.map(({ n, title, desc, Icon }) => (
              <div key={n} className="flex items-center gap-4 py-4 lg:flex-col lg:px-4 lg:py-2">
                <span
                  className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full text-sm font-extrabold text-[#2f241a] shadow-sm lg:h-11 lg:w-11 lg:text-lg"
                  style={{ background: '#F8B834' }}
                >
                  {n}
                </span>
                <div className="min-w-0 flex-1 text-right lg:text-center">
                  <p className="text-sm font-extrabold text-[#2f241a] lg:text-lg">{title}</p>
                  <p className="mt-0.5 text-[0.65rem] text-gray-500 lg:text-sm">{desc}</p>
                </div>
                <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-[#f2e7d5]">
                  <Icon />
                </span>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Welcome;
